import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { HiX } from "react-icons/hi";

export default function Sidebar({ isOpen, onClose = () => {}, children, className = "w-full md:w-[600px]" }) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={onClose}>
        <div className="min-h-screen">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-x-full"
                  enterTo="opacity-100 translate-x-0"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-x-0"
                  leaveTo="opacity-0 translate-x-full"
                >
                  <Dialog.Panel className={`pointer-events-auto relative ${className}`}>
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300 delay-[150ms]"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="flex h-full flex-col overflow-y-auto bg-white shadow-xl">
                        <div className="absolute right-0 top-0 z-10 flex pr-4 pt-4">
                          <button type="button" className="rounded-md p-2 text-gray-400 hover:text-gray-500 focus:outline-none hover:bg-gray-100" onClick={onClose}>
                            <span className="sr-only">Close panel</span>
                            <HiX className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                        {children}
                      </div>
                    </Transition.Child>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
